import { ThemeProvider } from '../contexts/ThemeContext';
import { AuthProvider } from '../contexts/AuthContext';
import { OrgCapabilitiesProvider } from '../contexts/OrgCapabilitiesContext';
import AppRoutes from '../routes/AppRoutes';

const App = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <OrgCapabilitiesProvider>
          <AppRoutes />
        </OrgCapabilitiesProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
